module.exports = __webpack_public_path__ + "static/img/aeft_icon.04d041d1.png";